import { atom, selector } from 'recoil';
import axios from 'axios';
/**
 * huobi 기준의 전일종가 데이터 호출
 * @author ydw <teammapa.ydw@gmail.com>
 * @function huobi_closing_price
 * @returns {object} reponse.data - usdt 전일 종가
 */

export const huobi_closing_price = async () => {
	try {
		const response = await axios.post(
			`${process.env.REACT_APP_BACKEND_API}/kct/huobi_global_kct_usdt_price`
		);
		return response.data;
	} catch (error) {
	} finally {
	}
};
